import { useState } from "react";
import { useAuth } from "../lib/AuthContext";
import { COLORS } from "../lib/colors";
import DashboardTab from "./DashboardTab";
import RequestsTab from "./RequestsTab";
import ChatTab from "./ChatTab";

const TABS = [
  { key: "home", label: "Home", icon: "\u2302" },
  { key: "requests", label: "Requests", icon: "\u2709" },
  { key: "chat", label: "Chat", icon: "\u2026" },
];

export default function AppShell() {
  const { candidate, signOut } = useAuth();
  const [activeTab, setActiveTab] = useState("home");
  const [pendingCount, setPendingCount] = useState(0);
  const [unreadChatCount, setUnreadChatCount] = useState(0);

  const initials = candidate?.name
    ? candidate.name.split(" ").map((n) => n[0]).join("").substring(0, 2).toUpperCase()
    : "?";

  return (
    <div style={{
      fontFamily: "'DM Sans', -apple-system, sans-serif",
      backgroundColor: COLORS.bg,
      minHeight: "100vh",
      maxWidth: 430,
      margin: "0 auto",
      position: "relative",
      display: "flex",
      flexDirection: "column",
    }}>
      <link
        href="https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,500;0,9..144,600;1,9..144,400&family=DM+Sans:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />

      {/* Header */}
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "14px 20px",
        position: "sticky",
        top: 0,
        zIndex: 10,
        backgroundColor: COLORS.bg,
        borderBottom: `1px solid ${COLORS.borderLight}`,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{
            width: 30, height: 30, borderRadius: 8, backgroundColor: COLORS.accent,
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "#fff", fontWeight: 700, fontSize: 14,
          }}>R</div>
          <span style={{ fontFamily: "'Fraunces', serif", fontWeight: 600, fontSize: 18, color: COLORS.text, letterSpacing: "-0.02em" }}>
            Relay
          </span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <button
            onClick={signOut}
            style={{
              background: "none", border: "none", color: COLORS.textMuted,
              fontSize: 12, fontFamily: "inherit", cursor: "pointer",
            }}
          >
            Sign out
          </button>
          <div style={{
            width: 32, height: 32, borderRadius: "50%",
            backgroundColor: COLORS.accentLight, color: COLORS.accent,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 12, fontWeight: 600,
          }}>
            {initials}
          </div>
        </div>
      </div>

      {/* Content */}
      <div style={{ flex: 1, paddingBottom: 80 }}>
        {activeTab === "home" && (
          <DashboardTab
            onNavigateRequests={() => setActiveTab("requests")}
            onPendingCount={setPendingCount}
          />
        )}
        {activeTab === "requests" && (
          <RequestsTab onPendingCount={setPendingCount} />
        )}
        {activeTab === "chat" && <ChatTab onUnreadCount={setUnreadChatCount} />}
      </div>

      {/* Bottom Nav */}
      <nav style={{
        position: "fixed",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: "100%",
        maxWidth: 430,
        display: "flex",
        backgroundColor: COLORS.surface,
        borderTop: `1px solid ${COLORS.border}`,
        paddingBottom: "env(safe-area-inset-bottom, 0px)",
        zIndex: 100,
      }}>
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
              padding: "10px 0 8px",
              border: "none",
              backgroundColor: "transparent",
              cursor: "pointer",
              fontFamily: "inherit",
              position: "relative",
            }}
          >
            <span style={{
              fontSize: 18,
              color: activeTab === tab.key ? COLORS.accent : COLORS.textMuted,
              lineHeight: 1,
            }}>
              {tab.icon}
            </span>
            <span style={{
              fontSize: 11,
              fontWeight: activeTab === tab.key ? 600 : 400,
              color: activeTab === tab.key ? COLORS.accent : COLORS.textMuted,
            }}>
              {tab.label}
            </span>

            {/* Pending badge on Requests tab */}
            {tab.key === "requests" && pendingCount > 0 && (
              <span style={{
                position: "absolute",
                top: 6,
                right: "calc(50% - 18px)",
                minWidth: 16, height: 16,
                borderRadius: 8,
                backgroundColor: COLORS.red,
                color: "#fff",
                fontSize: 10,
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 4px",
              }}>
                {pendingCount}
              </span>
            )}

            {/* Unread badge on Chat tab */}
            {tab.key === "chat" && unreadChatCount > 0 && (
              <span style={{
                position: "absolute",
                top: 6,
                right: "calc(50% - 18px)",
                minWidth: 16, height: 16,
                borderRadius: 8,
                backgroundColor: COLORS.accent,
                color: "#fff",
                fontSize: 10,
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 4px",
              }}>
                {unreadChatCount}
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
}
